// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-number-input-docs',
    templateUrl: './number-input.docs.generated.html',
})
export class UINumberInputDocs { }
